import type { FaireProductEntity } from "../../entity_types/product";

export const p_6t3z8ced2z: FaireProductEntity = {
  token: "p_6t3z8ced2z",
  type: "product",
  name: "Ultra-Lite Plush & Cozy Throw Blanket 54\"x72\"",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/bfea68c19aa1161ed6540a55b0df525c35da8be9ac24222b9f608018d4504ef8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c65a5ebfca6630d7c78e569b40b66af2f17c15dc8bb0f2d44dcd9aa9826e580.jpeg",
    "https://cdn.faire.com/fastly/3760f3f95f765e9854955814a301bf9d6fac72ec6ba55f84946334561e26ad84.jpeg",
    "https://cdn.faire.com/fastly/808db4761260169936999382f3c505339d81f866714bc197bdd3f91a887b2b54.jpeg",
    "https://cdn.faire.com/fastly/fb443d12a7c4e0bf9d612f6322b23cf11bec272f45290537708f19be58c30a70.jpeg"
  ],
  priceDollars: 60,
  description: "Wrap yourself in the 54” x 72” Ultra-Lite Marshmallow Blanket, a luxurious addition to your home that redefines cozy living. It features a looser weave, making it lighter in weight yet remarkably plush and soft, thanks to its high pile.\n\nIt's designed to be double the thickness of our typical Marshmallow fabric, delivering a layer of comfort and warmth that's simply irresistible. Whether draped over your bed or for curling up on the couch, this blanket is a versatile must-have that elevates both your decor and relaxation ritual.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n•\tPlush, lightweight and cozy\n•\t54” x 72” blanket",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:10.186Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
